module.exports = __webpack_public_path__ + "img/ZF WIND POWER LOGO.dae955ae.jpg";